export enum BADGE_LAYOUT {
  NAME_AND_ICON = 0,
  ICON_ONLY = 1,
  NAME_ONLY = 2,
}

export enum BADGE_SIZE {
  SMALL = 0,
  MEDIUM = 1,
  LARGE = 2,
}

export const APP_SETTINGS_MANAGE_BADGES_ORIGIN = 'App Settings';
export const APP_SETTINGS_ABOUT_MANAGE_BADGES_ORIGIN = 'app-setings.about';
export const ABOUT_MANAGE_BADGES_ORIGIN = 'UoU Viewer';

export const BADGES_LEARN_MORE_ARTICLE_ID = '92c45fbe-38e4-4fb9-b8c9-524c2251975a';

export const BUILD_WIX_SUPPORT_LINK = (supportId: string, locale: string) =>
  `https://support.wix.com/articles/id/${supportId}?locale=${locale}`;
